export const APP_LOGIN_ROUTE = '/login';
